import { t } from '@/i18n';
import { z } from 'zod';

export const modalFormSchema = z.object({
  title: z.string().min(1, t('pages.application_history_timeline.components.team_timeline_edit_modal.schema.required')),
  description: z.string().min(1, t('pages.application_history_timeline.components.team_timeline_edit_modal.schema.required')),
  year: z.number().gte(1500, t('pages.application_history_timeline.components.team_timeline_edit_modal.schema.required')),
  team_uuid: z.string().optional(),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
